// @generated by protoc-gen-es v1.7.0 with parameter "target=ts,import_extension=.ts"
// @generated from file plugnmeet_recorder.proto (package plugnmeet, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from '@bufbuild/protobuf';
/**
 * @generated from enum plugnmeet.RecordingTasks
 */
export var RecordingTasks;
(function (RecordingTasks) {
    /**
     * @generated from enum value: START_RECORDING = 0;
     */
    RecordingTasks[RecordingTasks["START_RECORDING"] = 0] = "START_RECORDING";
    /**
     * @generated from enum value: STOP_RECORDING = 1;
     */
    RecordingTasks[RecordingTasks["STOP_RECORDING"] = 1] = "STOP_RECORDING";
    /**
     * @generated from enum value: START_RTMP = 2;
     */
    RecordingTasks[RecordingTasks["START_RTMP"] = 2] = "START_RTMP";
    /**
     * @generated from enum value: STOP_RTMP = 3;
     */
    RecordingTasks[RecordingTasks["STOP_RTMP"] = 3] = "STOP_RTMP";
    /**
     * @generated from enum value: END_RECORDING = 4;
     */
    RecordingTasks[RecordingTasks["END_RECORDING"] = 4] = "END_RECORDING";
    /**
     * @generated from enum value: END_RTMP = 5;
     */
    RecordingTasks[RecordingTasks["END_RTMP"] = 5] = "END_RTMP";
    /**
     * @generated from enum value: RECORDING_PROCEEDED = 6;
     */
    RecordingTasks[RecordingTasks["RECORDING_PROCEEDED"] = 6] = "RECORDING_PROCEEDED";
    /**
     * @generated from enum value: STOP = 7;
     */
    RecordingTasks[RecordingTasks["STOP"] = 7] = "STOP";
})(RecordingTasks || (RecordingTasks = {}));
// Retrieve enum metadata with: proto3.getEnumType(RecordingTasks)
proto3.util.setEnumType(RecordingTasks, 'plugnmeet.RecordingTasks', [
    { no: 0, name: 'START_RECORDING' },
    { no: 1, name: 'STOP_RECORDING' },
    { no: 2, name: 'START_RTMP' },
    { no: 3, name: 'STOP_RTMP' },
    { no: 4, name: 'END_RECORDING' },
    { no: 5, name: 'END_RTMP' },
    { no: 6, name: 'RECORDING_PROCEEDED' },
    { no: 7, name: 'STOP' },
]);
/**
 * @generated from enum plugnmeet.RecorderServiceType
 */
export var RecorderServiceType;
(function (RecorderServiceType) {
    /**
     * @generated from enum value: RECORDING = 0;
     */
    RecorderServiceType[RecorderServiceType["RECORDING"] = 0] = "RECORDING";
    /**
     * @generated from enum value: RTMP = 1;
     */
    RecorderServiceType[RecorderServiceType["RTMP"] = 1] = "RTMP";
})(RecorderServiceType || (RecorderServiceType = {}));
// Retrieve enum metadata with: proto3.getEnumType(RecorderServiceType)
proto3.util.setEnumType(RecorderServiceType, 'plugnmeet.RecorderServiceType', [
    { no: 0, name: 'RECORDING' },
    { no: 1, name: 'RTMP' },
]);
/**
 * @generated from message plugnmeet.PlugNmeetToRecorder
 */
export class PlugNmeetToRecorder extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string from = 1;
         */
        this.from = '';
        /**
         * @generated from field: plugnmeet.RecordingTasks task = 2;
         */
        this.task = RecordingTasks.START_RECORDING;
        /**
         * @generated from field: int64 room_table_id = 3;
         */
        this.roomTableId = protoInt64.zero;
        /**
         * @generated from field: string room_id = 4;
         */
        this.roomId = '';
        /**
         * @generated from field: string room_sid = 5;
         */
        this.roomSid = '';
        /**
         * @generated from field: string recording_id = 6;
         */
        this.recordingId = '';
        /**
         * @generated from field: string recorder_id = 7;
         */
        this.recorderId = '';
        /**
         * @generated from field: string access_token = 8;
         */
        this.accessToken = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlugNmeetToRecorder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlugNmeetToRecorder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlugNmeetToRecorder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlugNmeetToRecorder, a, b);
    }
}
PlugNmeetToRecorder.runtime = proto3;
PlugNmeetToRecorder.typeName = 'plugnmeet.PlugNmeetToRecorder';
PlugNmeetToRecorder.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'from', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 2,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(RecordingTasks),
    },
    {
        no: 3,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 4, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 6,
        name: 'recording_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 7,
        name: 'recorder_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 8,
        name: 'access_token',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 9,
        name: 'rtmp_url',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.RecorderToPlugNmeet
 */
export class RecorderToPlugNmeet extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string from = 1;
         */
        this.from = '';
        /**
         * @generated from field: plugnmeet.RecordingTasks task = 2;
         */
        this.task = RecordingTasks.START_RECORDING;
        /**
         * @generated from field: bool status = 3;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 4;
         */
        this.msg = '';
        /**
         * @generated from field: string recording_id = 5;
         */
        this.recordingId = '';
        /**
         * @generated from field: int64 room_table_id = 11;
         */
        this.roomTableId = protoInt64.zero;
        /**
         * @generated from field: string room_id = 6;
         */
        this.roomId = '';
        /**
         * @generated from field: string room_sid = 7;
         */
        this.roomSid = '';
        /**
         * @generated from field: string recorder_id = 8;
         */
        this.recorderId = '';
        /**
         * @generated from field: string file_path = 9;
         */
        this.filePath = '';
        /**
         * next key 12
         *
         * @generated from field: float file_size = 10;
         */
        this.fileSize = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RecorderToPlugNmeet().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecorderToPlugNmeet().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecorderToPlugNmeet().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecorderToPlugNmeet, a, b);
    }
}
RecorderToPlugNmeet.runtime = proto3;
RecorderToPlugNmeet.typeName = 'plugnmeet.RecorderToPlugNmeet';
RecorderToPlugNmeet.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'from', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 2,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(RecordingTasks),
    },
    { no: 3, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'recording_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 11,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 6, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 7, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 8,
        name: 'recorder_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 9, name: 'file_path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 10, name: 'file_size', kind: 'scalar', T: 2 /* ScalarType.FLOAT */ },
]);
/**
 * @generated from message plugnmeet.FromParentToChild
 */
export class FromParentToChild extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.RecordingTasks task = 1;
         */
        this.task = RecordingTasks.START_RECORDING;
        /**
         * @generated from field: string recording_id = 2;
         */
        this.recordingId = '';
        /**
         * @generated from field: int64 room_table_id = 3;
         */
        this.roomTableId = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FromParentToChild().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FromParentToChild().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FromParentToChild().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FromParentToChild, a, b);
    }
}
FromParentToChild.runtime = proto3;
FromParentToChild.typeName = 'plugnmeet.FromParentToChild';
FromParentToChild.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(RecordingTasks),
    },
    {
        no: 2,
        name: 'recording_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 3,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
]);
/**
 * @generated from message plugnmeet.FromChildToParent
 */
export class FromChildToParent extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.RecordingTasks task = 1;
         */
        this.task = RecordingTasks.START_RECORDING;
        /**
         * @generated from field: bool status = 2;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 3;
         */
        this.msg = '';
        /**
         * @generated from field: string recording_id = 4;
         */
        this.recordingId = '';
        /**
         * @generated from field: int64 room_table_id = 5;
         */
        this.roomTableId = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FromChildToParent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FromChildToParent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FromChildToParent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FromChildToParent, a, b);
    }
}
FromChildToParent.runtime = proto3;
FromChildToParent.typeName = 'plugnmeet.FromChildToParent';
FromChildToParent.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(RecordingTasks),
    },
    { no: 2, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 4,
        name: 'recording_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 5,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
]);
/**
 * @generated from message plugnmeet.StartRecorderChildArgs
 */
export class StartRecorderChildArgs extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 room_table_id = 1;
         */
        this.roomTableId = protoInt64.zero;
        /**
         * @generated from field: string recording_id = 2;
         */
        this.recordingId = '';
        /**
         * @generated from field: string access_token = 4;
         */
        this.accessToken = '';
        /**
         * @generated from field: bool post_mp4_convert = 6;
         */
        this.postMp4Convert = false;
        /**
         * @generated from field: plugnmeet.RecorderServiceType serviceType = 8;
         */
        this.serviceType = RecorderServiceType.RECORDING;
        /**
         * @generated from field: string websocket_url = 11;
         */
        this.websocketUrl = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StartRecorderChildArgs().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartRecorderChildArgs().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartRecorderChildArgs().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartRecorderChildArgs, a, b);
    }
}
StartRecorderChildArgs.runtime = proto3;
StartRecorderChildArgs.typeName = 'plugnmeet.StartRecorderChildArgs';
StartRecorderChildArgs.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    {
        no: 2,
        name: 'recording_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 4,
        name: 'access_token',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 5, name: 'plug_n_meet_info', kind: 'message', T: PlugNmeetInfo },
    {
        no: 6,
        name: 'post_mp4_convert',
        kind: 'scalar',
        T: 8 /* ScalarType.BOOL */,
    },
    { no: 7, name: 'copy_to_path', kind: 'message', T: CopyToPath },
    {
        no: 8,
        name: 'serviceType',
        kind: 'enum',
        T: proto3.getEnumType(RecorderServiceType),
    },
    {
        no: 9,
        name: 'recorder_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 10,
        name: 'rtmp_url',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 11,
        name: 'websocket_url',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 12,
        name: 'custom_chrome_path',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 13,
        name: 'width',
        kind: 'scalar',
        T: 13 /* ScalarType.UINT32 */,
        opt: true,
    },
    {
        no: 14,
        name: 'height',
        kind: 'scalar',
        T: 13 /* ScalarType.UINT32 */,
        opt: true,
    },
    {
        no: 15,
        name: 'xvfb_dpi',
        kind: 'scalar',
        T: 13 /* ScalarType.UINT32 */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.PlugNmeetInfo
 */
export class PlugNmeetInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string host = 1;
         */
        this.host = '';
        /**
         * @generated from field: string api_key = 2;
         */
        this.apiKey = '';
        /**
         * @generated from field: string api_secret = 3;
         */
        this.apiSecret = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlugNmeetInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlugNmeetInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlugNmeetInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlugNmeetInfo, a, b);
    }
}
PlugNmeetInfo.runtime = proto3;
PlugNmeetInfo.typeName = 'plugnmeet.PlugNmeetInfo';
PlugNmeetInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'host', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'api_key', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'api_secret', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 4,
        name: 'join_host',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.CopyToPath
 */
export class CopyToPath extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string main_path = 1;
         */
        this.mainPath = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CopyToPath().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CopyToPath().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CopyToPath().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CopyToPath, a, b);
    }
}
CopyToPath.runtime = proto3;
CopyToPath.typeName = 'plugnmeet.CopyToPath';
CopyToPath.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'main_path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 2,
        name: 'sub_path',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
